import { render } from "./CreateButton.vue?vue&type=template&id=25eca422&scoped=true"
import script from "./CreateButton.vue?vue&type=script&lang=js"
export * from "./CreateButton.vue?vue&type=script&lang=js"

import "./CreateButton.vue?vue&type=style&index=0&id=25eca422&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25eca422"]])

export default __exports__